import { getBaseUrl, request } from 'src/helper/api';

export const getQualityCheckData = (token?: string, workOrderId?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/work-orders/${workOrderId}/quality-check-info`,
      contentType: 'json',
      token,
      signal,
    },
    'getQualityCheckData',
  );

export const updateLaborCost = (token?: string, workOrderId?: string, tripId?: string) =>
  request(
    {
      method: 'PATCH',
      url: `${getBaseUrl()}api/work-orders/${workOrderId}/trip/${tripId}/actions/updateTripCost`,
      contentType: 'json',
      token,
    },
    'work-order/updateLaborCost',
    { tripId },
  );

export const updateDriveOrLaborTime = (workOrderId?: string, tripId?: string, token?: string) =>
  request(
    {
      method: 'PATCH',
      url: `${getBaseUrl()}api/work-orders/${workOrderId}/trip/${tripId}/actions/updateTripTime`,
      contentType: 'json',
      token,
    },
    'quality-check/updateDriveOrLaborTime',
    { tripId },
  );

export const getQCIssueExpandedData = (
  token?: string,
  workOrderId?: string,
  issueId?: string,
  signal?: AbortSignal,
) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/work-orders/${workOrderId}/quality-check-issue/${issueId}`,
      contentType: 'json',
      token,
      signal,
    },
    'getQCIssueExpandedData',
  );

export const addQCMaterial = (token?: string, workOrderId?: string, workOrderIssueId?: string) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/work-orders/${workOrderId}/issues/${workOrderIssueId}/actions/addMaterial`,
      contentType: 'json',
      token,
    },
    'quality-check/addMaterial',
    { workOrderIssueId },
  );

export const deleteQCMaterial = (
  token?: string,
  workOrderId?: string,
  workOrderIssueId?: string,
  materialId?: string,
) =>
  request(
    {
      method: 'DELETE',
      url: `${getBaseUrl()}api/work-orders/${workOrderId}/issues/${workOrderIssueId}/material/${materialId}/actions/deleteMaterial`,
      contentType: 'json',
      token,
    },
    'quality-check/deleteMaterial',
    { workOrderIssueId, materialId },
  );

export const updateQCMaterial = (
  token?: string,
  workOrderId?: string,
  workOrderIssueId?: string,
  materialId?: string,
) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/work-orders/${workOrderId}/issues/${workOrderIssueId}/material/${materialId}/actions/updateMaterial`,
      contentType: 'json',
      token,
    },
    'quality-check/updateMaterial',
    { workOrderIssueId },
  );

export const saveQualityCheckData = (token?: string, workOrderId?: string, issueId?: string) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/work-orders/${workOrderId}/issue/${issueId}/actions/updateTripDetails`,
      contentType: 'json',
      token,
    },
    'quality-check/saveQualityCheckData',
  );

export const submitQualityCheckData = (token?: string, workOrderId?: string) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/work-orders/${workOrderId}/actions/submitQualityCheck`,
      contentType: 'json',
      token,
    },
    'quality-check/submitQualityCheckData',
  );
